import axios from 'axios'
var Buffer = require('buffer/').Buffer

const username = wpvue_script_data_params.data.site_data.api_auth_user
const password = wpvue_script_data_params.data.site_data.api_auth_pass
const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')

let HttpClient = {}
if (!wpvue_script_data_params.data.site_data.disable_auth) {
    HttpClient = axios.create({
        baseURL: `${wpvue_script_data_params.rest_api_url}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${token}`
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
    })
} else {
    HttpClient = axios.create({
        baseURL: `${wpvue_script_data_params.rest_api_url}`,
        headers: {
            'Content-Type': 'application/json',
        },
        maxContentLength: 20000,
        maxBodyLength: 20000,
    })
}

export default HttpClient


// WEBPACK FOOTER //
// ./src/api/HttpClient.js